import React from 'react';
import ProviderEditForm from '@/portal/routes/providers/components/ProviderEditForm.tsx';

const ProviderNewPage: React.FC = () => {
  return <ProviderEditForm />;
};

export default ProviderNewPage;
